export const parseStockConditionInputValue = (inputValue: string): number | null => {
  if (inputValue === '') {
    return null;
  }

  return Number(inputValue);
};

export const formatStockConditionInputValue = (fieldValue: unknown): string => {
  if (typeof fieldValue === 'number' && Number.isFinite(fieldValue)) {
    return String(fieldValue);
  }

  return '';
};
